import { CheckItem } from '@app/models/_index';
import { Factory } from './_factory';
import { FilterCatalogItemService } from '@app/services/_index';
import { Injectable } from '@angular/core';
import { Learning_Type, Learning_Type_Description } from '@app/enums/_index';

/**
 * Create Learning Type CheckItem Factory used by application
 * Creates instances of Learning Type Check Items.
 */
@Injectable({
  providedIn: 'root',
})
export class LearningTypeCheckItemFactory implements Factory<CheckItem> {
  learningTypes: CheckItem[] = [];
  isBuilding = false;

  /**
   * Call and build Learning Type Check Items array.
   * Do not add or remove items from this array.
   * Used as a read-only reference.
   */
  constructor(private filterCatalogItems: FilterCatalogItemService) {}

  /**
   * Build static learning types check items array to be used to determine the Course learning type
   * Used to show and filter tooltips for a given course detail
   */
  async build(): Promise<void> {
    if (this.isBuilding) {
      return;
    }
    this.isBuilding = true;

    try {
      // Donot change the param value for getAllObjects function as it is the fieldName of the Learning Type in Docebo
      const getLearningTypes = await this.filterCatalogItems.getAllObjects('Learning Type');
      console.log('Learning Type filters from Docebo:', getLearningTypes);
      if (getLearningTypes && getLearningTypes.length > 0) {
        getLearningTypes.forEach((alllearningTypes) => {
          const learningTypesTooltipText = this.getlearningTypeTooltip(alllearningTypes?.value);
          this.learningTypes.push(
            new CheckItem(
              alllearningTypes?.value.toLowerCase().trim(),
              alllearningTypes?.value,
              false,
              alllearningTypes?.value,
              learningTypesTooltipText
            )
          );
        });
      }
    } catch (error) {
      console.error('Error Building learningTypes', error);
    } finally {
      this.isBuilding = false;
    }
  }

  /**
   * Return immutable or copy of Learning Type Check Items collection
   * @returns - a slice or copy of thes static collection
   */
  getCollection(): CheckItem[] {
    if (this.learningTypes && this.learningTypes.length === 0 && !this.isBuilding) {
      this.build();
    }
    return this.learningTypes;
  }

  /**
   * Tooltip-text for the Learning Types
   * @param learningType
   * @returns the tooltip text for the Learning Types
   */
  getlearningTypeTooltip(learningType: string): string {
    switch (learningType) {
      case Learning_Type.SELF_STUDY:
        return Learning_Type_Description.SELF_STUDY;
      case Learning_Type.QUICK_LEARNING:
        return Learning_Type_Description.QUICK_LEARNING;
      case Learning_Type.INSTRUCTOR_LED:
        return Learning_Type_Description.INSTRUCTOR_LED;
      case Learning_Type.E_LEARNING:
        return Learning_Type_Description.E_LEARNING;
      case Learning_Type.CERTIFICATION_EXAM:
        return Learning_Type_Description.CERTIFICATION_EXAM;
      case Learning_Type.WEBINAR:
        return Learning_Type_Description.WEBINAR;
      case Learning_Type.WORKSHOP:
        return Learning_Type_Description.WORKSHOP;
      default:
        return 'Tooltip text will be updated soon';
    }
  }
}
